import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getBuyRequestsList } from '../../../actions/buyRequestsActions';
import { BUY_REQUESTS_STATUS } from '../../../constants/buyRequestsConstants';
import ProspectsListTable from './ProspectsListTable';

const Prospects = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBuyRequestsList({ query: { status: BUY_REQUESTS_STATUS.PROSPECTS } }));
  }, []);

  return (
    <>
      <ProspectsListTable />
    </>
  );
}

export default Prospects;
